<template>
  <div :id="$attrs['id']" :class="[{'item-nav--visible': navVisible}, 'item-nav--item-nav-visible', {'item-nav--save-in-progress': saveInProgress}]" class="item-nav">
    <div :class="[{'item-nav__header--white': $route.meta.headerMode === 'white'}, `item-nav__header--${env('WHITE_LABEL_KEY')}`]" class="item-nav__header" @click="onClickLogo">
      <span class="item-nav__header__label">{{ $t('menu.back') }}</span>
    </div>
    <nav class="item-nav__nav">
      <ul class="item-nav__ul">
        <slot />
      </ul>
    </nav>
  </div>
</template>

<script>

import { isEmpty, throttle } from 'lodash';
import { hideAll } from 'tippy.js';
import HotelmeisterMixin from '../../../../mixins/HotelmeisterMixin';
import UpdateHotelSettingsMixin from '../../../../mixins/UpdateHotelSettingsMixin';

export default {
  name: 'ItemNav',
  mixins: [HotelmeisterMixin, UpdateHotelSettingsMixin],

  props: [],

  data() {
    return {
      onClickLogo: throttle(this._onClickLogo, 1000, { leading: true, trailing: false }),
    };
  },

  beforeRouteLeave(to, from, next) {
    this.$store.dispatch('layout/navVisible', false);
    hideAll({ duration: 0 });

    next();
  },

  computed: {
    saveInProgress: function () {
      return this.$store.getters['save/saveInProgress'];
    },
    navVisible: function () {
      return this.$store.getters['layout/navVisible'];
    },
  },

  created: function () {
    this.$serviceBus.$on('closeNav', () => {
      this.$store.dispatch('layout/navVisible', false);
      hideAll({ duration: 0 });
    });
  },

  mounted: function () {
    this.$emit('widenav', true);
  },

  methods: {
    env: function (name) {
      return process.env[name];
    },
    _onClickLogo: function () {
      if (!isEmpty(this.$route.meta.parent)) {
        this.$router.push({
          name: this.$route.meta.parent,
          params: {
            ...this.$route.params,
            expandedSubmenu: this.$route.meta.expandedSubmenu,
          },
        });
      }
      if (this.$route.meta.headerMode === 'white') {
        this.$root.$emit('clickHeaderBack');
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
  // @import '~styles/main';
  @import '~styles/components/lib/ItemNav';

</style>



// WEBPACK FOOTER //
// src/components/lib/layout/nav/ItemNav.vue